import { render, staticRenderFns } from "./CompanyFinancialConfig.vue?vue&type=template&id=319bb268&scoped=true&"
import script from "./CompanyFinancialConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyFinancialConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFinancialConfig.vue?vue&type=style&index=0&id=319bb268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319bb268",
  null
  
)

export default component.exports